var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.412 16 3.0666-3.0667c0.3867-0.3867 0.3867-1.0267 0-1.4133-0.3866-0.3867-1.0266-0.3867-1.4133 0l-3.0667 3.0666-3.0667-3.0666c-0.3866-0.3867-1.0266-0.3867-1.4133 0-0.3867 0.3866-0.3867 1.0266 0 1.4133l3.0667 3.0667-3.0667 3.0666c-0.3867 0.3867-0.3867 1.0267 0 1.4133 0.2 0.2001 0.4533 0.2934 0.7067 0.2934 0.2533 0 0.5066-0.0933 0.7066-0.2934l3.0667-3.0666 3.0667 3.0666c0.2 0.2001 0.4533 0.2934 0.7067 0.2934 0.2533 0 0.5066-0.0933 0.7066-0.2934 0.3867-0.3866 0.3867-1.0266 0-1.4133l-3.0666-3.0666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.a5d624797f2a602423ccdf756bdc875d.svg";
export { ForwardRef as ReactComponent };